module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event/event_waso_try-e50caa73aa560a2c1ea2c8a0ad7d2b16.jpg";